import { Th, Text } from '@chakra-ui/react';
import React from 'react';

export const TableHeader = ({
  name,
  style,
}: {
  name: string;
  style?: React.CSSProperties;
}) => {
  return (
    <Th style={style}>
      <Text
        color="black"
        fontSize="16px"
        padding="8px 0px"
        whiteSpace="pre-wrap"
        lineHeight="20px"
      >
        {name}
      </Text>
    </Th>
  );
};
